import React from "react";

import { Line } from "react-chartjs-2";
import {
  PointElement,
  LineElement,
  CategoryScale,
  Legend,
  LinearScale,
  Title,
  Tooltip,
  Filler,
  Chart as chartJS,
} from "chart.js";

chartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend
);

const ctx = document.createElement("canvas").getContext("2d");

/*** Gradient ***/
var gradient = ctx.createLinearGradient(0, 0, 0, 510);
gradient.addColorStop(0, "rgba(196,202,250,1)");
gradient.addColorStop(1, "rgba(246,247,254,1)");

const JsonData = [
  { label: "1", value: "12" },
  { label: "2", value: "14" },
  { label: "3", value: "20" },
  { label: "4", value: "23" },
  { label: "5", value: "15" },
  { label: "6", value: "12" },
  { label: "7", value: "8" },
  { label: "8", value: "23" },
  { label: "9", value: "17" },
  { label: "10", value: "13" },
];

const data = {
  labels: JsonData.map(item => item.label),
  datasets: [
    {
      label: "Risk Levels",
      data: JsonData.map(item => item.value),

      borderColor: "#374bf6",

      fill: {
        target: "origin",
        above: gradient,
      },

      borderWidth: 2,
      pointColor: "#fff",
      pointBackgroundColor: "#fff",
      pointStrokeColor: "#ff6c23",
      // pointHighlightFill: "#fff",
      // pointHighlightStroke: "#ff6c23",

      tension: 0.5,
    },
  ],
};
// const options = {
//     scales: {

//         x: {
//             grid: {
//               display: false,
//             },
//         },
//       y: {
//         min:5,
//         max:25,
//         ticks: {
//             beginAtZero: true,
//             callback: function (value) {
//               return value + '%'; // Append '%' to each tick value
//             },
//             stepSize: 5, // Set step size to 5% intervals

//           },
//           grid: {
//             display: true,
//             color: "#f4f4f4"
//           },
//       },

//     },
//   };

const options = {
  plugins: {
    tooltip: {
      enabled: true,
      callbacks: {
      
        label: function (context) {
          let label = context.dataset.label || "";

          if (label) {
            label += ": ";
          }
          if (context.parsed.y !== null) {
            label += context.parsed.y + "%";
          }
          return label;
        },
        labelColor: function (context) {
          return {
            borderColor: "rgb(0, 0, 255)",
            backgroundColor: "rgb(255, 0, 0)",
            borderWidth: 2,
            // borderDash: [2, 2],
            borderRadius: 2,
          };
        },
        labelTextColor: function (context) {
          return "#ffcc00";
        },
      },
    },

    // title: {
    //   display: true,
    //   text: ,
    //   position: 'bottom',
    // },
    legend: {
      display: false, // Hide legend
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      stacked: true,
      title: {
        display: true,
        text: "No of trades",
      },
      //
    },
    y: {
      min: 5,
      max: 25,
      ticks: {
        beginAtZero: true,
        callback: function (value) {
          return value + "%"; // Append '%' to each tick value
        },
        stepSize: 5, // Set step size to 5% intervals
      },
      grid: {
        display: true,
        color: "#f4f4f4",
        z: 1, // Set z-index to 0
      },
      border: { dash: [2, 2] },
      stacked: true,
      title: {
        display: true,
        text: "Risk Per Trade",
      },
    },
  },
  
};

export default function LineChart() {
  return (
    <div className="App">
      <Line data={data} options={options} />
    </div>
  );
}
